export const ERROR_RECEIVE = 'ERROR_RECEIVE'
export const GETADVERTISELIST_REQUEST = 'GETADVERTISELIST_REQUEST'
export const GETADVERTISELIST_RECEIVE = 'GETADVERTISELIST_RECEIVE'

export const GETPRODUCTLIST_REQUEST = 'GETPRODUCTLIST_REQUEST'
export const GETPRODUCTLIST_RECEIVE = 'GETPRODUCTLIST_RECEIVE'

export const GETPRODUCT_REQUEST = 'GETPRODUCT_REQUEST'
export const GETPRODUCT_RECEIVE = 'GETPRODUCT_RECEIVE'

export const GETINCOMEDETAIL_REQUEST = 'GETINCOMEDETAIL_REQUEST'
export const GETINCOMEDETAIL_RECEIVE = 'GETINCOMEDETAIL_RECEIVE'

export const GETUSERBALANCE_REQUEST = 'GETUSERBALANCE_REQUEST'
export const GETUSERBALANCE_RECEIVE = 'GETUSERBALANCE_RECEIVE'

export const GETPURCHASEHI_REQUEST = 'GETPURCHASEHI_REQUEST'
export const GETPURCHASEHI_RECEIVE = 'GETPURCHASEHI_RECEIVE'

export const PAY_REQUEST = 'PAY_REQUEST'
export const PAY_RECEIVE = 'PAY_RECEIVE'